import { FieldMap, Form, WithId } from '../types'

export const emptyForm: Form = {
  description: '',
  name: '',
  stages: {},
}

export const emptyStage: WithId<FieldMap> = {
  id: '',
  name: '',
  children: {},
}
